// generated from 10_417 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastPurchaseSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_purchase_since_filter"),
  comparison_key: z.enum([
    "4", // 4_616 (44.31%)
    "6", // 3_585 (34.41%)
    "5", // 1_382 (13.27%)
    "3", // 834 (8.01%)
  ]),
  display_name: z.string(),
  // undefined: 2_803 (26.91%), defined 7_614 (73.09%)
  raw_value: z
    .union([
      // number samples: 5_847 (76.79%)
      // integer: 5_358 (91.64%)
      // avg: 119.47, min: 0, max: 1825
      z.number().min(0),
      // string samples: 1_767 (23.21%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 8_201 (78.73%)
    // integer: 7_304 (89.06%)
    // avg: 136.07, min: 0, max: 1825
    z.number().min(0),
    // string samples: 2_216 (21.27%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
